import { SET_ACTIVE_DEVICE } from './action-names';

export function setActiveDevice(device) {
  return {
    type: SET_ACTIVE_DEVICE,
    device
  };
}



// WEBPACK FOOTER //
// ./app/header-builder/actions/device-link-actions.js